import { IQuery } from 'core-ts-types';
import { StcCustomContentsModel } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-orm';
import { APCustomText } from './../../../../custom_texts/builders/custom_text_builder';
import { IAPCustomTextDatasource } from './../../../../custom_texts/datasources/custom_text_datasource';
import { APUserModeConfig } from './../../../../global/components/user_mode_config/config/ap_user_mode_config';
import { FeedbackSuggestedPlanModel } from './../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from './../../../../suggestions/components/plan_feedback/servants/plan_feedback_servant';
import { IAPPlannerResourceTab } from './../builders/planner_resource_tab_builder';
import {
  PlannerResourceFavoriteTab,
  PlannerResourceMAPTab,
  PlannerResourceSearchTab,
  PlannerResourceTabs
} from './../constants/planner_resource_tabs';
import { APSelectedPlannerResourceTab } from './../models/selected_planner_resource_tab_model';

export class APPlannerResourceTabsQuery implements IQuery {
  private __result: {
    tabs: IAPPlannerResourceTab[];
    selectedTab: IAPPlannerResourceTab;
    isMapActive: boolean;
    isSearchActive: boolean;
    isFavoritesActive: boolean;
  };

  constructor(
    private ngAPSelectedPlannerResourceTab: APSelectedPlannerResourceTab,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
    private ngAPCustomTextDatasource: IAPCustomTextDatasource,
    private appConfigModel: any,
    private ngStcCustomContentsModel: StcCustomContentsModel
  ) {
    ORMMediator.registerQuery(
      this,
      ngAPSelectedPlannerResourceTab,
      ngFeedbackSuggestedPlanModel,
      ngStcCustomContentsModel
    );
  }

  updateScheduleAppointmentTab(tabs: IAPPlannerResourceTab[]) {
    const schedulingEnabled = this.appConfigModel.isFeatureEnabled('ssccampus-appointment_scheduling');
    const isAdvisor = this.ngAPUserModeConfig.isAdvisor();
    const defaultAppointmentMenu = _4.find(tabs, { key: 'SCHEDULE_APPOINTMENT' });

    if (!schedulingEnabled || isAdvisor) {
      return _4.pull(tabs, defaultAppointmentMenu);
    }

    defaultAppointmentMenu.title = _4.get(
      this.ngStcCustomContentsModel.read(),
      'student_scheduling.student_scheduler_button_text',
      defaultAppointmentMenu.title
    );
    return tabs;
  }

  run() {
    const _plannerResourceTabs = this._isSearchEnabled
      ? PlannerResourceTabs
      : _4.filter(PlannerResourceTabs, (tab: IAPPlannerResourceTab) => tab.key !== 'SEARCH');
    const advisorInViewMode = PlanFeedbackServant.isPlanReadOnlyMode(this.ngFeedbackSuggestedPlanModel.read());
    const fullTabListAvailable = !(this.ngAPUserModeConfig.isAdvisor() && advisorInViewMode);

    const tabs = fullTabListAvailable ? _plannerResourceTabs : [PlannerResourceMAPTab];
    this.updateScheduleAppointmentTab(tabs);

    const DEGREE_MAP_TITLE_NK = 'AP_DEGREE_MAP_TITLE';

    const modifiedMapTitle = _4.get(
      this.ngAPCustomTextDatasource.get(DEGREE_MAP_TITLE_NK) as APCustomText,
      'text',
      PlannerResourceMAPTab.title
    );

    const titleChangedTabs = tabs.map((tab) => {
      if (tab.key === PlannerResourceMAPTab.key) {
        tab.title = modifiedMapTitle;
      }
      return tab;
    });

    const selectedTab = this.ngAPSelectedPlannerResourceTab.read();

    const activeTabs = titleChangedTabs.map((tab) => ({
      ...tab,
      active: selectedTab.key === tab.key
    }));

    this.__result = {
      tabs: activeTabs,
      selectedTab,
      isMapActive: selectedTab.key === PlannerResourceMAPTab.key,
      isSearchActive: selectedTab.key === PlannerResourceSearchTab.key,
      isFavoritesActive: selectedTab.key === PlannerResourceFavoriteTab.key
    };
    return this;
  }

  get _isSearchEnabled() {
    const isSmartCatalogEnabled = this.appConfigModel.isFeatureEnabled('academicplan-smart_catalog');
    const isSearchEnabled = this.appConfigModel.isFeatureEnabled('reg-course_search');
    return isSearchEnabled || isSmartCatalogEnabled;
  }

  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPPlannerResourceTabsQuery', APPlannerResourceTabsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_resources/queries/planner_resource_tabs_query.ts